import { render } from "./SectionsDetailQuestionsUnitedMeasures.vue?vue&type=template&id=52703f0e"
import script from "./SectionsDetailQuestionsUnitedMeasures.vue?vue&type=script&lang=js"
export * from "./SectionsDetailQuestionsUnitedMeasures.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__